<template>
  <div>
    <!-- toasts message -->
        <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <v-btn
      color="primary"
      dark
      slot="activator"
      class="mb-2"
      :to="`/training/training-info-form`"
      @click="_link"
    >New</v-btn>

    <v-card-title>
      <h2>Training Informations</h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

     <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>
        <td class="text-xs-left">{{ props.item.training_code }}</td>
        <td class="text-xs-left">{{ props.item.training_title }}</td>
        <td class="text-xs-left">{{ props.item.start_date }}</td>
        <td class="text-xs-left">{{ props.item.end_date }}</td>
        <td class="text-xs-left">{{ props.item.venue }}</td>
        <td class="text-xs-left">
          <span v-if="props.item.is_open == 1" class="active">Open</span>
          <span v-else-if="props.item.is_open == 0" class="in-active">Close</span>
          <span v-else class="in-active">Plan</span>
        </td>
         <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="viewDetails(props.item)" title="Detail">
              <v-icon color="teal">view_module</v-icon>
            </v-btn>
          <v-btn icon class="mx-0" @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteItem(props.index, props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import { preFix } from "../../../vuex/api";
import Axios from "axios";

export default {
  data: () => ({
    valid: true,
    dialog: false,
    dialogEditForm: false,

    selected: [],

    delete_id: "",
    row_index: "",
    dialog2: false,
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    message: "",

    select: null,
    typelist: [
      { name: "Type 1", id: 1 },
      { name: "Type 2", id: 2 },
      { name: "Type 3", id: 3 }
    ],

     formSchema: {
        id: 0,
        operation_id:"",
        training_code:"",
        training_title: "",
        training_cat_id: "",
        training_type: "",
        is_open: "",
        venue: "",
        organizer_id: "",
        start_date:"",
        end_date: "",
        ida_amount: "",
        GoB_amount: "",

      },

    /*############# Datatable #############*/
    serialNumber: 0,
    sort: '',
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},
    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
    headers: [
      {
        text:'SL',
        value:'',
      },
      {
        text: "Training Code",
        align: "left",
        sortable: true,
        value: "training_code"
      },
      { text: "Training Title", align: "left", sortable: true, value: "training_title" },
      { text: "Start Date", align: "left", sortable: true, value: "start_date" },
      { text: "End Date",sortable: true, value: "end_date" },
      { text: "Venue", sortable: true, value: "venue" },
      { text: "Open/Close", sortable: true, value: "is_open" },
      { text: "Organizer Name", sortable: true, value: "name" },
      { text: "Action", value: "" }
    ]
    /*############# /Datatable #############*/
  }),

  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.totalRecords;
        });
      },
      deep: true
    }
  },
  
  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    },
    _link() {
        sessionStorage.removeItem('training_info')
        return '/training/training-info-form';
    }
  },

  methods: {
    viewDetails(item)
    {
      sessionStorage.setItem("trainInfoId", item.id); 
      this.$router.push('/training/training-info-details');
    },
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
          this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data,"training_information")
          // .getAllData("training_info")
          .then(res => {
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            // if (rowsPerPage > 0) {
            //   items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage);
            // }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    editItem(index, item) {
      this.row_index = index;
      this.formSchema = item;
      sessionStorage.setItem("training_info", item.id);      
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
      this.$router.push('/training/training-info-form');
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "training_info").then(res => {
        if (res.status == 1) {
          this.desserts.splice(row_index);
          this.SnackbarVal.color = 'success';
          this.SnackbarVal.message = res.message;
          this.SnackbarVal.snackbar = true;
          this.confirmModel = false;
          this.dialog2 = false;

          this.getDataFromApi();
        } else {
          this.SnackbarVal.color = 'error';
          this.SnackbarVal.message = res.message;
          this.snackbar = true;
        }
      });
    },

    close(res) {
      if (res.action == "add") {
        this.items.push(res.data);
      }
      if (res.action == "edit") {
        this.items[this.row_index] = res.data;
      }

      this.message = res.message;
      this.snackbar = true;
      this.row_index = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/training/training_information/training_info_list.vue